"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggleColorScheme = void 0;
const isServer_1 = require("@uxf/core/utils/isServer");
const react_1 = require("react");
const context_1 = require("../context");
function useToggleColorScheme() {
    const { respectSystemSetting, respectUserSettings, getUserSettings, setUserSettings } = (0, context_1.useComponentContext)("colorScheme");
    return (0, react_1.useCallback)(() => {
        if (isServer_1.isServer) {
            return;
        }
        const userSettings = getUserSettings();
        let inverseColorScheme;
        if (userSettings && respectUserSettings) {
            document.body.classList.remove(userSettings);
            inverseColorScheme = userSettings === "light" ? "dark" : "light";
        }
        else if (respectSystemSetting) {
            const userColorScheme = window.matchMedia(`(prefers-color-scheme: dark)`).matches ? "dark" : "light";
            document.body.classList.remove(userColorScheme);
            inverseColorScheme = userColorScheme === "light" ? "dark" : "light";
        }
        if (inverseColorScheme) {
            document.body.classList.add(inverseColorScheme);
            setUserSettings(inverseColorScheme);
        }
    }, [getUserSettings, respectSystemSetting, respectUserSettings, setUserSettings]);
}
exports.useToggleColorScheme = useToggleColorScheme;
